<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="create">
      {{ $t('db.group.button.create') }}
    </i-button>

    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import FilterComponent from '@db/components/db-groups/db-groups-table-filter';
  import TableComponent from '@db/components/db-groups/db-groups-table';
  import { GroupModalService } from '@db/modals/GroupModalService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterComponent,
      TableComponent
    },

    methods: {
      ...mapActions('db/groups/table', ['getAsyncData']),

      create: function() {
        GroupModalService.create().on('success', () => this.getAsyncData({ current_page: 1 }));
      }
    }
  };
</script>
